
import React from 'react';
import "./Sealing.css";

function Products() {
  return (
    <div className='products-container'>
      <div className="products-content">

        <div className='products-header'>
          <h3>SIZDIRMAZLIK TEKNOLOJİSİ KAUÇUK HAMURLARI</h3>
        </div>

        <div className='pro-text-promotion'>
          <h3>SIZDIRMAZLIK TEKNOLOJİSİ KAUÇUK HAMURLARI</h3>

          <p>Kauçuk, elastik özellikleri ve sıvılara karşı yüksek direnci ile bilindiği için, sızdırmazlık ürünlerinde de yaygın olarak kullanılan bir malzemedir. Ayrıca geniş bir sıcaklık aralığında aşınmaya ve yırtılmaya karşı dirençlidir. Kauçuktan yapılan sızdırmazlık elemanları titreşim önler aynı zamanda hava ve su geçirmezdir.
          </p>
          <p>High Performance Compounds olarak sızdırmazlık ürünlerinde uluslararası standartları karşılayan, müşteri ihtiyaçlarına uygun olarak tasarlanan formülasyonlarımızla çözüm ortağınız olarak hizmetinizdeyiz.</p>


        </div>









        <div className='products-features'>
          <div className='products-features-header'>
            <h3>ÜRÜN ÖZELLİKLERİ</h3>
          </div>
          <p><strong>Elastomer :</strong>EPDM, NBR, AEM, ACM, SBR, HNBR, IIR bazlı hamurlar</p>
          <p><strong>Sertlik :</strong>40-80 ShA</p>
          <p><strong>Çapraz Bağlama :</strong>Kükürt, peroksit ya da amin pişirici</p>
          <p><strong>Üretim Metodu :</strong>Enjeksiyon ve Kompresyon süreçleri ile uyumlu</p>
          <p><strong>Kullanım Alanları :</strong>Otomotiv, beyaz eşya sektörlerinde kullanılmaktadır.</p>
        </div>



        <div className='info-contact'>
          <button className='btn-contact'>Teklif almak için bizimle iletişime geçebilirsiniz</button>
        </div>

      </div>
    </div>
  )
}

export default Products
